/**
 * What the product URL field sends to the API, from whatever was typed into it.
 *
 * The API requires a scheme, because the address is rendered as a link and a scheme-less `href`
 * resolves against our own domain. Nobody types one, so `panenco.com` becomes `https://panenco.com`
 * rather than a validation error. Empty means the product has no address, which is `null` — an empty
 * string would be stored as one.
 */
export const toProductUrl = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;

  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};
